import { UserInfoService } from '@appStore/account/services/user-info.service';
import { NotificationService } from '@appStore/account/services/notification.service';
import { SettingsService } from '@appStore/account/services/settings.service';
import { MessagesService } from '@appStore/account/services/messages.service';
import { WidgetService } from '@appStore/account/services/widget.service';
import { UserNotificationSettingsService } from '@appStore/account/services/user-notification-settings.service';
import { UserMarketingSettingsService } from '@appStore/account/services/user-marketing-settings.service'; 
import { AccessRequestService } from '@appStore/account/services/access-request.service';

export const services: any[] = [
  UserInfoService,
  NotificationService,
  SettingsService,
  MessagesService,
  WidgetService,
  UserNotificationSettingsService,
  UserMarketingSettingsService,
  AccessRequestService
];

export * from '@appStore/account/services/user-info.service';
export * from '@appStore/account/services/notification.service';
export * from '@appStore/account/services/settings.service';
export * from '@appStore/account/services/messages.service';
export * from '@appStore/account/services/widget.service';
export * from '@appStore/account/services/user-notification-settings.service';
export * from '@appStore/account/services/user-marketing-settings.service';
export * from '@appStore/account/services/access-request.service';
